module.exports = __webpack_public_path__ + "img/logo-rosobrnadzor.fe26d51c.png";